export default __webpack_public_path__ + "static/media/master.06a5df4f.png";